import { render, staticRenderFns } from "./viewAssessment.vue?vue&type=template&id=495a3040"
import script from "./viewAssessment.vue?vue&type=script&lang=js"
export * from "./viewAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports